var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Closures"},[_c('div',{staticClass:"reportBasic-subTitle"},[_vm._v("\n    "+_vm._s(_vm.$tc('lang.LoadingReport.Seal_Container'))+"\n  ")]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(" "+_vm._s(_vm.$tc('lang.LoadingReport.Seal')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.closures.lmediaSeal,"otherData":{
          mediaName: '铅封',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaSeal',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Seal_No')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.closures.lmediaSealno,"otherData":{
          mediaName: '铅封号',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaSealno',
        },"id":_vm.id}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }